<div class="card flex flex-wrap gap-3 mb-3">

  <div class="p-2 border-1 surface-border border-round">

    <h3>Datos de entidad</h3>

    <form [formGroup]="form">

      <div class="flex">

        <div class="form-column">
          <label for="txtTitle">Título</label>
          <input type="text" id="txtTitle" pInputText formControlName="title" />
        </div>

        <p-button label="Editar" icon="pi pi-pencil" (click)="editProperties()"></p-button>

      </div>


    </form>

  </div>

</div>

<div class="card flex flex-wrap gap-3 card-fields">

  <div class="p-2 border-1 surface-border border-round w-full">

    <div class="flex align-items-center justify-content-between mb-3">
      <h3>Campos</h3>
      <p-button label="Añadir campo" icon="pi pi-plus" (click)="addField()"></p-button>
    </div>

    <form [formGroup]="formFields">

      <ng-container formArrayName="fields">

        <ng-container *ngFor="let formField of getFormFields.controls; let i = index">

          <div class="form-field" [formGroupName]="i">
            
            <p-button icon="pi pi-times"  severity="danger" (click)="deleteField(i)"></p-button>

            <input type="text" class="field-title" id="txtTitle" pInputText formControlName="title" />
            
            <p-dropdown [options]="fieldTypes" appendTo="body" formControlName="fieldType" optionLabel="title"
              optionValue="id" placeholder="Tipo de campo"></p-dropdown>

          </div>

        </ng-container>

      </ng-container>

    </form>

  </div>


</div>